// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import {} from 'jquery';
import {} from 'jquery.inputmask';
import validate from 'validate.js';

require('materialize');

jQuery(($) => {
  $('#referral_phone').inputmask({
    mask: '(999) 999-9999',
    showMaskOnHover: false,
  });

  $('a').each((index, anchor) => {
    anchor.search = window.location.search
  });

  let emailInput = $("input[type='email']");
  // configurate global email validation
  emailInput.on('change', (event) => {
    let input = $(event.target);
    let submitBtn = input.closest('form').find("[type='submit']")
    let error = getEmailErrors(input);
    submitBtn.attr('disabled', !!error);
  });

  emailInput.closest('form').on('submit', (e) => {
    let emailField = $(e.target).find("[type='email']");
    let isEmailHasError = !!getEmailErrors(emailField);
    return !isEmailHasError;
  });

  let getEmailErrors = (input) =>  {
    let inputField = input.parent();
    let error = validate.single(input.val(), {
      // Email is required
      presence: true,
      // and must be an email (duh)
      email: true
    });
    inputField
      .attr('data-error', error)
      .toggleClass('input-field--error', !!error);

    return error;
  };
});
